module.exports = __webpack_public_path__ + "img/jichang.d9f4f0ac.png";